import React from "react";
import { useLocation } from "react-router-dom";
import { usePermissions } from "../../hooks/usePermissions";
import { findRoutePermission } from "../../auth/permissions";
import PermissionDenied from "./PermissionDenied";

const RoutePermissionGate = ({ children, capability, minLevel = "R" }) => {
  const location = useLocation();
  const { hasPermission } = usePermissions();
  const required = capability
    ? { capability, minLevel }
    : findRoutePermission(location.pathname);

  if (required && !hasPermission(required.capability, required.minLevel || "R")) {
    return <PermissionDenied />;
  }

  return children;
};

export default RoutePermissionGate;
